module.exports = __webpack_public_path__ + "img/TF.d4d8e9b3.png";